export default "__VITE_ASSET__hsj3PUS___"